import React, { Component } from 'react'

class SearchItemDates extends Component {
	getPostDateBegin = () => {
		// Validation robuste des props
		if (!this.props.postItem || !this.props.postItem._source || !this.props.postItem._source.date_begin_timestamp) {
			return ''
		}

		try {
			const dateBegin = new Date(this.props.postItem._source.date_begin_timestamp * 1000)
			return new Intl.DateTimeFormat('fr-FR', {day: '2-digit', month: 'long'}).format(dateBegin)
		} catch (error) {
			console.warn('Erreur lors du formatage de la date de début:', error)
			return ''
		}
	}

	getPostDateEnd = () => {
		// Validation robuste des props
		if (!this.props.postItem || !this.props.postItem._source || !this.props.postItem._source.date_end_timestamp) {
			return ''
		}

		try {
			const dateEnd = new Date(this.props.postItem._source.date_end_timestamp * 1000)
			const dateEndReturn = new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: 'long' }).format(dateEnd)
			
			const dateBegin = new Date(this.props.postItem._source.date_begin_timestamp * 1000)
			const dateBeginCheck = new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: 'long' }).format(dateBegin)
			
			return dateEndReturn !== dateBeginCheck ? dateEndReturn : ''
		} catch (error) {
			console.warn('Erreur lors du formatage de la date de fin:', error)
			return ''
		}
	}

	getPostDatesClass = () => {
		if (this.props.postItemMini) {
			return 'search-list-item-head-date search-list-mini-item-head-date'
		}
		return 'search-list-item-head-date'
	}

	render = () => {
		const dateBegin = this.getPostDateBegin()
		
		// Ne rendre que si la date de début existe
		if (!dateBegin) {
			return null
		}

		const dateEnd = this.getPostDateEnd()

		return (
			<p 
				className={this.getPostDatesClass()}
				role="text"
				aria-label={`Date de l'événement: ${dateBegin}${dateEnd ? ' - ' + dateEnd : ''}`}
			>
				<span>{dateBegin}</span>
				{dateEnd && (
				  <>
				    {' - '}
				    <span>{dateEnd}</span>
				  </>
				)}
			</p>
		)
	}
}

export default SearchItemDates;
